/** @format */

import React, { useEffect } from 'react';
import Header from 'components/Layout/Header';
import Footer from 'components/Layout/Footer';
import Container from 'react-bootstrap/Container';
import BrokerProfileContent from 'views/Common/BrokerProfile/BrokerProfileContent';
import getUrlParams from 'utils/getUrlParams';
import { useDispatch, useSelector } from 'react-redux';
import {
  fetchBrokerObjects,
  fetchBrokerObjectsBySlug,
  fetchBrokerProfile,
  fetchBrokerProfileBySlug,
  clearBrokerObject
} from 'stateContainer/actions';
import CustomButton from 'components/CustomButton';
import { Link, useParams, useHistory } from 'react-router-dom';
import PageLoader from 'components/PageLoader';

export default function BrokerProfile(props) {
  const dispatch = useDispatch();
  const {
    brokerProfile: {
      data: { user, searchable, isAdminView },
      isFetching,
      isFetchingMore
    },
    brokerObjects: { data, isFetching: isObjectsFetching, page, totalPages }
  } = useSelector((state) => state);

  let history = useHistory();

  const { tprop } = props;

  const { profileId, profileRef } = getUrlParams(['profileId', 'profileRef']);

  const { profileSlug } = useParams();

  const target = React.useRef(null);
  const [show, setShow] = React.useState(false);

  const [copyProfileUrlSuccess, setCopyProfileUrlSuccess] = React.useState('');
  const [twoSecAfterLoad, setTwoSecAfterLoad] = React.useState(false);
  const [filteringData, setFilteringData] = React.useState({
    statuses: []
  });

  const copyToClipBoard = async (copiedText) => {
    await navigator.clipboard.writeText(copiedText);
    setCopyProfileUrlSuccess(tprop.header.copyLink.text);
  };

  const onClickCopyProfile = () => {
    const trimmedUrl = window.location.href.split('&')[0];
    copyToClipBoard(trimmedUrl);
    setShow(!show);
    setTimeout(() => {
      setShow(false);
    }, 1500);
  };

  const isProfileVisible = searchable || isAdminView;
  const isLoading = isFetching || isObjectsFetching;

  useEffect(() => {
    dispatch(clearBrokerObject());

    setTimeout(() => {
      setTwoSecAfterLoad(true);
    }, 2000);
  }, []);

  useEffect(() => {
    const statusPayload = {};

    if (filteringData.statuses.length > 0) {
      statusPayload.statuses = filteringData.statuses.join(',');
    }

    if (profileId) {
      dispatch(
        fetchBrokerProfile({
          brokerId: profileId,
          profileRef
        })
      );
      isProfileVisible &&
        dispatch(
          fetchBrokerObjects({
            ...statusPayload,
            brokerId: profileId,
            profileRef
          })
        );
    } else if (profileSlug) {
      dispatch(
        fetchBrokerProfileBySlug({
          brokerSlug: profileSlug,
          profileRef
        })
      );
      isProfileVisible &&
        dispatch(
          fetchBrokerObjectsBySlug({
            ...statusPayload,
            brokerSlug: profileSlug,
            profileRef
          })
        );
    }
  }, [searchable, isAdminView, filteringData.statuses]);

  useEffect(() => {
    if (!isProfileVisible && !isLoading && twoSecAfterLoad) {
      history.push('/hidden');
    }
  }, [isProfileVisible, isLoading, twoSecAfterLoad]);

  const ProfileContent = () => {
    return (
      <Container fluid className='content-wrapper'>
        {user !== undefined && (
          <>
            <BrokerProfileContent
              {...props}
              properties={data}
              muncipality={user.muncipality}
              brokerEmail={user.fmEmail}
              brokerPhone={user.phonenumber}
              copyToClipBoard={copyToClipBoard}
              copyProfileUrlSuccess={copyProfileUrlSuccess}
              onClickCopyProfile={onClickCopyProfile}
              target={target}
              show={show}
              status={user.status}
              activeObjectCount={user.activeObjectCount}
              completedSalesCount={user.completedSalesCount}
              showCopySuccess={show}
              firstName={user.firstName}
              lastName={user.lastName}
              profilePic={user.image}
              description={user.description}
              services={user.services}
              usps={user.usp}
              totalPages={totalPages}
              page={page}
              profileId={profileId}
              profileSlug={profileSlug}
              isFetchingMore={isFetchingMore}
              profileRef={profileRef}
              region={user?.region}
              filteringData={filteringData}
              setFilteringData={setFilteringData}
            />
          </>
        )}
      </Container>
    );
  };

  const ProfileNotPublic = () => {
    return (
      <Container
        fluid
        className='content-wrapper broker-profile-not-public-container'>
        <div className='broker-profile-not-public-actions'>
          <h2>{tprop.profile_not_public.heading.text}</h2>
          <Link to={tprop.profile_not_public.button.url}>
            <CustomButton text={tprop.profile_not_public.button.text} />
          </Link>
        </div>
        <div className='image-broker-profile-not-public' />
      </Container>
    );
  };

  const Loader = () => {
    if (isLoading) {
      return (
        <Container fluid className='broker-profile-loading-container'>
          <PageLoader />
        </Container>
      );
    }

    return <></>;
  };

  return (
    <>
      <div className='main-container broker-profile-view'>
        <Header flow={props.flow} showContactSellerButton={true} {...props} />

        <Loader />

        {isProfileVisible && !isLoading && <ProfileContent />}

        {!isProfileVisible && !isLoading && <ProfileNotPublic />}

        <Footer {...props} />
      </div>

      <div className='main-container broker-profile-view-mobile'>
        <Header flow={props.flow} showContactSellerButton={true} {...props} />

        <Loader />

        {isProfileVisible && !isLoading && <ProfileContent />}

        {!isProfileVisible && !isLoading && <ProfileNotPublic />}

        <Footer {...props} />
      </div>
    </>
  );
}
